import Logger from 'src/core/utils/Logger'

export const parseData = <T = unknown>(data: unknown, type: 'object' | 'array' = 'object') => {
  const defaultValue = type === 'object' ? {} : []

  try {
    if (!data) {
      return defaultValue as T
    }
    if (typeof data === 'string') {
      return JSON.parse(data as string) as T
    }
    return data as T
  } catch (err: unknown) {
    Logger.error(err)
  }

  return defaultValue as T
}
